import { useQuery } from 'react-query';
import type { CustomUseQueryOptions } from '../requests-types/custom-use-query-options';
import { getPrivateApi } from '../../../services/api';
import { GetExportedIntegrationsResponse, GetExportedIntegrationsResponseSchema } from '@vy/api-definition';
import { queryKeys } from '../../../services/query-key/query-keys';

export function useExportedInvoiceIntegration(
  invoiceId: string,
  options?: CustomUseQueryOptions<GetExportedIntegrationsResponse>,
) {
  return useQuery({
    queryKey: queryKeys.exportedInvoiceIntegration(invoiceId),
    queryFn: async () => {
      const api = getPrivateApi();

      const exportedInvoiceIntegrations = await api.getExportedIntegrations({
        invoiceId,
      });

      return GetExportedIntegrationsResponseSchema.parse(exportedInvoiceIntegrations);
    },
    ...options,
  });
}
